import { render, staticRenderFns } from "./GlobalTitle.vue?vue&type=template&id=06ba57b8&scoped=true"
import script from "./GlobalTitle.vue?vue&type=script&lang=js"
export * from "./GlobalTitle.vue?vue&type=script&lang=js"
import style0 from "./GlobalTitle.vue?vue&type=style&index=0&id=06ba57b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ba57b8",
  null
  
)

export default component.exports